"use strict";

class bb_itemEngine {
  constructor() {
    this.url_params = new URLSearchParams(window.location.search);

    let httpHeader = {};
    let request = new Request(api_itemURL + this.url_params.toString(), {
      method: "GET",
      headers: new Headers(httpHeader),
    });
    omekaAPI.getItemWithAllMedia(request).then(
      function (data) {
        this.renderItem(data);
      }.bind(this)
    );
    // End of Constructor
  }

  renderItem(data) {
    this.itemData = data;
    this.mainContainer = document.querySelector("[bb_app-template=item]");
    this.renderHeader();
    this.renderImages();
    this.renderVideos();
    this.renderDocuments();
    this.renderAudio();
    this.renderVarious();
    this.renderBody();
    this.renderMoreFromTags();
  }

  renderHeader() {
    let created;
    if (typeof this.itemData["o:created"]) {
      let createdRaw = new Date(this.itemData["o:created"]["@value"]);
      created =
        createdRaw.getUTCDate() +
        "." +
        (createdRaw.getUTCMonth() + 1) +
        "." +
        createdRaw.getUTCFullYear() +
        " / " +
        createdRaw.getUTCHours() +
        ":" +
        createdRaw.getUTCMinutes() +
        ":" +
        createdRaw.getUTCSeconds();
    } else {
      created = "Keine Angabe";
    }

    let template = document.getElementById("bbItemHeaderContainerTemplate");
    template.content.getElementById("dcterms:title").textContent = this.itemData["dcterms:title"][0]["@value"];
    template.content.getElementById("o:created").textContent = `${created}`;
    let clone = document.importNode(template.content, true);
    this.mainContainer.appendChild(clone);
  }

  renderImages() {
    let allImages = this.itemData["o:media"].filter(function (element) {
      if (element["o:media_type"].includes("image")) {
        return element;
      }
    });
    if (allImages.length == 0) {
      return;
    }

    if (allImages.length == 1) {
      let template = document.getElementById("bbItemMediaContainerSingleImagesTemplate");
      template.content.querySelector("a").href = allImages[0]["o:original_url"];
      template.content.querySelector("img").src = allImages[0]["thumbnail_display_urls"]["large"];
      let clone = document.importNode(template.content, true);
      this.mainContainer.appendChild(clone);
    }

    if (allImages.length >= 2) {
      let template = document.getElementById("bbItemMediaContainerMultipleImagesWrapper");
      let clone = document.importNode(template.content, true);
      this.mainContainer.appendChild(clone);
      let imageContainer = document.getElementById("splideList");

      template = document.getElementById("bbItemMediaContainerMultipleImagesItemTemplate");

      allImages.forEach((element) => {
        template.content.querySelector("a").href = element["o:original_url"];
        template.content.querySelector("img").src = element["thumbnail_display_urls"]["large"];
        clone = document.importNode(template.content, true);
        imageContainer.appendChild(clone);
      });

      if (allImages.length == 2) {
        let container = document.querySelector(".bb-item-mediaContainer-multipleImages");
        container.style.maxWidth = "1080px";
        container.style.margin = "20px auto";
      }

      new Splide(".bb-item-slider", {
        type: "slide",
        gap: 20,
        height: 600,
        autoWidth: true,
        focus: "left",
        pagination: false,
        cover: true,
        breakpoints: {
          768: {
            height: 500,
          },
        },
      }).mount();
    }
  }

  renderVideos() {
    let allVideos = this.itemData["o:media"].filter(function (element) {
      if (element["o:media_type"].includes("video")) {
        return element;
      }
    });
    if (allVideos.length == 0) {
      return;
    }

    let template = document.getElementById("bbItemMediaContainerVideo");
    allVideos.forEach((element, index) => {
      if (index == 1) {
        template.content.querySelector("h2").remove();
      }
      template.content.querySelector("source").src = element["o:original_url"] + "#t=0.5";
      template.content.querySelector("source").type = element["o:media_type"];
      let clone = document.importNode(template.content, true);
      this.mainContainer.appendChild(clone);
    });
  }

  renderDocuments() {
    let allDocuments = this.itemData["o:media"].filter(function (element) {
      if (element["o:media_type"].includes("pdf")) {
        return element;
      } else if (element["o:media_type"].includes("opendocument.spreadsheet")) {
        return element;
      } else if (element["o:media_type"].includes("opendocument.text")) {
        return element;
      }
    });
    if (allDocuments.length == 0) {
      return;
    }

    let template = document.getElementById("bbItemMediaContainerDocument");
    let baseUrl = template.content.querySelector("iframe").src;
    allDocuments.forEach((element, index) => {
      if (index == 1) {
        template.content.querySelector("h2").remove();
      }
      template.content.querySelector("iframe").src = baseUrl + element["o:filename"];
      let clone = document.importNode(template.content, true);
      this.mainContainer.appendChild(clone);
    });
  }

  renderAudio() {
    let allAudios = this.itemData["o:media"].filter(function (element) {
      if (element["o:media_type"].includes("audio")) {
        return element;
      }
    });

    if (allAudios.length == 0) {
      return;
    }

    let template = document.getElementById("bbItemMediaContainerAudioTemplate");
    let clone = document.importNode(template.content, true);
    this.mainContainer.appendChild(clone);
    let playlistContainer = document.getElementById("audioPlaylist");
    template = document.getElementById("bbItemMediaContainerAudioItemTemplate");

    allAudios.forEach((element) => {
      template.content.getElementById("o:original_url_skip").href = element["o:original_url"];
      template.content.getElementById("o:original_url_download").href = element["o:original_url"];
      template.content.getElementById("o:source").textContent = element["o:source"];
      clone = document.importNode(template.content, true);
      playlistContainer.appendChild(clone);
    });

    this.startAudioPlayer();
  }

  renderVarious() {
    let allVarious = this.itemData["o:media"].filter(function (element) {
      if (element["o:media_type"].includes("audio")) {
        return;
      }
      if (element["o:media_type"].includes("image")) {
        return;
      }
      if (element["o:media_type"].includes("video")) {
        return;
      }
      if (element["o:media_type"].includes("pdf")) {
        return;
      } else if (element["o:media_type"].includes("opendocument.spreadsheet")) {
        return;
      } else if (element["o:media_type"].includes("opendocument.text")) {
        return;
      }
      if (element["o:media_type"].includes("audio")) {
        return;
      }
      return element;
    });

    if (allVarious.length == 0) {
      return;
    }

    let template = document.getElementById("bbItemFileContainerWrapperTemplate");
    let clone = document.importNode(template.content, true);
    this.mainContainer.appendChild(clone);
    let filelistContainer = document.getElementById("bbItemFileContainerList");
    template = document.getElementById("bbItemFileContainerItemTemplate");

    allVarious.forEach((element) => {
      template.content.getElementById("o:source").textContent = element["o:source"];
      template.content.getElementById("o:media_type").textContent = element["o:media_type"];
      template.content.getElementById("o:size").textContent = Math.round(element["o:size"] / 1024) + " kb";
      template.content.getElementById("o:original_url").href = element["o:original_url"];
      clone = document.importNode(template.content, true);
      filelistContainer.appendChild(clone);
    });
  }

  renderBody() {
    let template = document.getElementById("bbItemInfoContainerTemplate");

    // Required Fields
    if (this.itemData["dcterms:description"]) {
      let fullDescription = "";
      this.itemData["dcterms:description"].forEach((element) => {
        fullDescription += element["@value"];
        fullDescription += "\n\n";
      });

      template.content.getElementById("dcterms:description").textContent = fullDescription;
    } else {
      template.content.getElementById("dcterms:description").textContent = "Keine Angabe";
    }

    if (this.itemData["dcterms:creator"]) {
      template.content.getElementById("dcterms:creator").textContent = this.itemData["dcterms:creator"][0]["@value"];
    } else {
      template.content.getElementById("dcterms:creator").textContent = "Keine Angabe";
    }

    if (this.itemData["dcterms:rights"]) {
      template.content.getElementById("dcterms:rights").textContent = this.itemData["dcterms:rights"][0]["@value"];
    } else {
      template.content.getElementById("dcterms:rights").textContent = "Keine Angabe";
    }

    if (this.itemData["dcterms:creator"] && this.itemData["dcterms:rights"]) {
      template.content.getElementById(
        "bb:quoteInstruction"
      ).textContent = `"${this.itemData["dcterms:title"][0]["@value"]}" von ${this.itemData["dcterms:creator"][0]["@value"]}, ${this.itemData["dcterms:rights"][0]["@value"]}, coronarchiv, online unter: https://www.coronarchiv.de/item?id=${this.itemData["o:id"]}`;
    } else {
      template.content.getElementById("bb:quoteInstruction").textContent = "Keine Angabe";
    }

    // Optional Fields
    if (this.itemData["dcterms:date"]) {
      template.content.getElementById("dcterms:date").textContent = this.itemData["dcterms:date"][0]["@value"];
    } else {
      template.content.getElementById("dcterms:date").textContent = "Keine Angabe";
    }

    if (this.itemData["dcterms:spatial"]) {
      template.content.getElementById("dcterms:spatial").textContent = this.itemData["dcterms:spatial"][0]["@value"];
    } else {
      template.content.getElementById("dcterms:spatial").textContent = "Keine Angabe";
    }

    if (this.itemData["dcterms:contributor"]) {
      template.content.getElementById("dcterms:contributor").textContent =
        this.itemData["dcterms:contributor"][0]["@value"];
    } else {
      template.content.getElementById("dcterms:contributor").textContent = "Keine Angabe";
    }

    let clone = document.importNode(template.content, true);
    this.mainContainer.appendChild(clone);

    if (this.itemData["o-module-mapping:marker"]) {
      this.createMap();
    } else {
      document.getElementById("bbItemMap").style.display = "none";
    }

    this.createShareLinks();
    this.createCopyButton();
  }

  startAudioPlayer() {
    const wavesurfer = WaveSurfer.create({
      container: "#waveform",
      waveColor: "#1F4B4E",
      progressColor: "#879d24",
      cursorWidth: "0",
      barHeigt: "1.5",
      barWidth: "2",
      barGap: "2",
      backend: "MediaElement",
    });

    // Create Play/Stop Event Listener
    let playPause = document.querySelector("#audioPlayPause");
    playPause.addEventListener("click", function () {
      wavesurfer.playPause();
    });

    // Toggle play/pause text
    wavesurfer.on("play", function () {
      document.querySelector("#audioPause").style.display = "";
      document.querySelector("#audioPlay").style.display = "none";
    });
    wavesurfer.on("pause", function () {
      document.querySelector("#audioPlay").style.display = "";
      document.querySelector("#audioPause").style.display = "none";
    });

    // The playlist links
    let links = document.querySelectorAll("#audioPlaylist .audioSkipSong");
    let currentTrack = 0;

    // Load a track by index and highlight the corresponding link
    let setCurrentSong = function (index) {
      links[currentTrack].parentElement.parentElement.classList.remove("playlisteActiveTrack");
      currentTrack = index;
      links[currentTrack].parentElement.parentElement.classList.add("playlisteActiveTrack");
      wavesurfer.load(links[currentTrack].href);
    };

    // Load the track on click
    Array.prototype.forEach.call(links, function (link, index) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        setCurrentSong(index);
      });
    });

    // Go to the next track on finish
    wavesurfer.on("finish", function () {
      setCurrentSong((currentTrack + 1) % links.length);
    });

    // Load the first track
    setCurrentSong(currentTrack);
  }

  createMap() {
    let map = L.map("bbItemMap").setView([20, 0], 2);
    L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);
    let latLng = [
      this.itemData["o-module-mapping:marker"][0]["o-module-mapping:lat"],
      this.itemData["o-module-mapping:marker"][0]["o-module-mapping:lng"],
    ];
    let marker = new L.marker(latLng).addTo(map);
    let markerBounds = L.latLngBounds(latLng, latLng);
    map.fitBounds(markerBounds);
    map.invalidateSize();
    map.invalidateSize();
  }

  createShareLinks() {
    let buttons = document.querySelectorAll(".bbItemShareLink");
    buttons.forEach((element, index) => {
      let baseUrl = element.href;
      element.href = baseUrl + window.location.href;
    });
  }

  createCopyButton() {
    let bbItemCopyButton = document.getElementById("bbItemCopyButton");
    let bbCopyIcon = document.querySelector("#bbItemCopyButton i");

    if (typeof ClipboardItem == "function") {
      bbItemCopyButton.addEventListener("click", (event) => {
        const value = document.getElementById("bb:quoteInstruction").textContent;
        const type = "text/plain";
        const blob = new Blob([value], { type });
        let data = [new ClipboardItem({ [type]: blob })];
        navigator.clipboard.write(data).then(
          () => {
            bbCopyIcon.classList.add("copySuccess");
            bbCopyIcon.addEventListener("animationend", () => {
              bbCopyIcon.classList.remove("copySuccess");
            });
          },
          () => {
            bbCopyIcon.classList.add("copyFail");
            bbCopyIcon.addEventListener("animationend", () => {
              bbCopyIcon.classList.remove("copyFail");
            });
          }
        );
      });
    } else {
      bbItemCopyButton.style.display = "none";
    }
  }

  renderMoreFromTags() {
    if (!this.itemData["dcterms:alternative"]) {
      return;
    }

    let hashtags = [];
    let hashtagsQueryLinks = [];
    let biggestHashtag = 0;
    let biggestHashtagName = "";
    let timer = 0;

    this.htmlElement = document.getElementById("bbItemMoreFromTagRowContainerTemplate").content;
    this.headlineBox = this.htmlElement.querySelector("h2 a");
    this.itemThumbnailElements = this.htmlElement.querySelectorAll("[data-target=thumbnail]");
    this.itemTitleElements = this.htmlElement.querySelectorAll("[data-target=title]");
    this.itemLinkElements = this.htmlElement.querySelectorAll(".bb-moreFromTagRowLink");
    this.hashtagList = this.htmlElement.querySelector("#bbMoreFromTagRowHashtagList");

    hashtags = this.itemData["dcterms:alternative"][0]["@value"].split(" ").filter((word) => word.startsWith("#"));

    hashtags.forEach((element) => {
      let httpHeader = {};
      let requestParams = new URLSearchParams();
      requestParams.set("property[0][joiner]", "and");
      requestParams.set("property[0][property]", 17);
      requestParams.set("property[0][type]", "in");
      requestParams.set("property[0][text]", element);
      let request = new Request(api_infoURLClean + "/items?" + requestParams.toString(), {
        method: "GET",
        headers: new Headers(httpHeader),
      });
      hashtagsQueryLinks.push(request);
    });

    function getAllItemCounts(links) {
      return Promise.all(links.map((url) => fetch(url).then((response) => response.json())));
    }

    getAllItemCounts(hashtagsQueryLinks)
      .then(
        function (allItemCounts) {
          allItemCounts.forEach((element, index) => {
            if (element.total > timer) {
              timer = element.total;
              biggestHashtag = index;
              biggestHashtagName = hashtags[index];
            }
          });

          return hashtagsQueryLinks[biggestHashtag].url;
        }.bind(this)
      )
      .then(
        function (rawLink) {
          let cleanURL = new URL(rawLink.replace("/infos/", "/"));
          let httpHeader = {};
          let requestParams = new URLSearchParams();
          requestParams.set("per_page", 4);
          requestParams.set("media_types[0]", "image/jpeg");
          requestParams.set("media_types[1]", "image/pjpeg");
          requestParams.set("media_types[2]", "image/png");
          requestParams.set("sort_by", "created");
          requestParams.set("sort_order", "desc");
          let request = new Request(cleanURL + "&" + requestParams.toString(), {
            method: "GET",
            headers: new Headers(httpHeader),
          });

          return omekaAPI.getItemOnly(request);
        }.bind(this)
      )
      .then(
        function (response) {
          let currentUrl = new URL(window.location);
          let currentParams = new URLSearchParams(currentUrl.search);
          let langParam = "";

          if (currentParams.has("lang")) {
            langParam = "&lang=" + currentParams.get("lang");
          } else {
            langParam = "";
          }

          this.headlineBox.textContent = biggestHashtagName;
          this.headlineBox.href = `/archiv/?&property[0][joiner]=and&property[0][property]=17&property[0][type]=in&property[0][text]=${encodeURIComponent(
            biggestHashtagName
          )}${langParam}`;

          hashtags.forEach((element) => {
            let li = document.createElement("li");
            let a = document.createElement("a");
            a.textContent = element;
            a.href = `/archiv/?&property[0][joiner]=and&property[0][property]=17&property[0][type]=in&property[0][text]=${encodeURIComponent(
              element
            )}${langParam}`;
            li.appendChild(a);
            this.hashtagList.appendChild(li);
          });

          response.forEach((element, index) => {
            this.itemThumbnailElements[index].src = element.thumbnail_display_urls.square;
            this.itemTitleElements[index].textContent = element["dcterms:title"][0]["@value"];
            this.itemLinkElements[index].href = `/item/?id=${element["o:id"]}${langParam}`;
          });

          let clone = document.importNode(this.htmlElement, true);
          this.mainContainer.appendChild(clone);
        }.bind(this)
      );
  }

  // End of Class
}

//TODO: DER PATHNAME WIRD SICH IN ANDEREN SPRACHEN ÄNDENR. ABER WILLST DU WARTEN BIS DER DOM GERENDERT WURDE?
let pathname = window.location.pathname;
const url_params = new URLSearchParams(window.location.search);

if (pathname.includes("/item/") && url_params.has("id")) {
  const itemEngine = new bb_itemEngine();
}
